import { openLayersPanel } from '../hiddenElementsStateManagementUtils';
import { closeMobileHiddenPanel } from '../hiddenElementsApi';
import { reportClickToOpenLayersPanelBI } from '../hiddenElementsBI';

import type { HiddenElementsScope } from '../hiddenElementsScope';
import type { HiddenElement } from '../hiddenElementsTypes';

export interface MobileHiddenPanelStateProps {
  hiddenElementsTotalCount: number;
  masterPageHiddenElements: HiddenElement[];
  focusedPageHiddenElements: HiddenElement[];
  interactionsHiddenElements: HiddenElement[];
  focusedPageId: string;
  focusedPageTitle: string;
}

export const mapStateToProps = (
  scope: HiddenElementsScope,
): MobileHiddenPanelStateProps => {
  const { editorAPI, store } = scope;

  return {
    hiddenElementsTotalCount: store.getHiddenElementsTotalCount(),
    masterPageHiddenElements: store.getMasterPageHiddenElements(),
    focusedPageHiddenElements: store.getFocusedPageHiddenElements(),
    interactionsHiddenElements: store.getInteractionsHiddenElements(),
    focusedPageId: editorAPI.pages.getFocusedPageId(),
    focusedPageTitle: editorAPI.pages.getCurrentUrlPageTitle(),
  };
};

export interface MobileHiddenPanelDispatchProps {
  showHelp: () => void;
  closePanel: () => void;
  showLayersPanel: () => void;
  refreshHiddenElements: () => void;
}

export const mapDispatchToProps = (
  scope: HiddenElementsScope,
): MobileHiddenPanelDispatchProps => {
  const { editorAPI, privateApi } = scope;

  return {
    refreshHiddenElements: privateApi.refreshHiddenElements,

    showHelp: () => {
      const helpId = '769b8807-30b7-4ee4-8a7b-93674099732f';
      editorAPI.panelManager.openHelpCenter(helpId);
    },

    showLayersPanel: () => {
      reportClickToOpenLayersPanelBI();
      openLayersPanel(editorAPI);
    },

    closePanel: () => closeMobileHiddenPanel(scope),
  };
};
